// Module
var code = "<div> <input class=\"form-control\" bs-switch ng-model=\"model[options.key]\" type=\"checkbox\" switch-on-text=\"Ways\" switch-off-text=\"Paylines\" switch-on-color=\"secondary\" switch-off-color=\"warning\" ng-false-value=\"'Paylines'\" ng-true-value=\"'Ways'\"/> </div>";
// Exports
export default code;